import * as React from 'react';

import { dollarFormatter, dollarFormatterUnitPrice } from 'af-utils/format.util';

import styles from './styles.module.scss';

interface Props {
	value: number;
	className?: string;
	isUnitPrice?: boolean;
	maxFractionDigits?: number;
	minFractionDigits?: number;
}

const DollarCell: React.FC<Props> = ({ value, className, isUnitPrice = false, maxFractionDigits, minFractionDigits }) => {
	const classNames: string[] = [styles['dollar-cell']];

	const formattedValue = isUnitPrice
		? dollarFormatterUnitPrice(maxFractionDigits, minFractionDigits).format(value)
		: dollarFormatter.format(value);

	if (className) {
		classNames.push(className);
	}

	if (value < 0) {
		classNames.push(styles['dollar-cell__negative']);
	}

	return (
		<div className={classNames.join(' ')}>
			{formattedValue}
		</div>
	);
};

export default React.memo(DollarCell);
